import request from '@/plugins/request';
import utils from '@/utils';
import { IUser } from '@/types/models';
import { AxiosResponse } from 'axios';

const $url = '/connect';

interface IGetResult {
  isAuthenticated: boolean;
  user: IUser;
  token: string;
}

export default {
  get(success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url)
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
